<template>
  <v-alert v-if="visible" id="watch-live-training" outlined color="success" class="mb-4" icon="mdi-watch">
    <div class="d-flex justify-space-between align-center">
      <strong>{{ statusText }}</strong><span class="ml-3">{{ duration }}</span>
    </div>
    <div v-if="state.exerciseTitle" class="mt-1">{{ state.exerciseTitle }}</div>
    <div v-if="state.setNumber && !finished" class="caption">Satz {{ state.setNumber }} von {{ state.setCount }} · {{ state.targetText }}</div>
    <div v-if="restSeconds > 0 && !finished" class="mt-1">Satzpause · {{ formatDuration(restSeconds) }}</div>
    <div class="caption mt-2">{{ stale ? 'Letzter Watch-Stand – Abgleich ausstehend.' : finished ? 'Der Trainingsverlauf wird nach der Übertragung aktualisiert.' : 'Dieses Training steuerst du auf der Apple Watch.' }}</div>
  </v-alert>
</template>

<script>
import trainingLiveService from "@/services/trainingLiveService"

export default {
  data: () => ({ live: trainingLiveService.viewState, now: Date.now(), timer: null }),
  computed: {
    state() { return this.live.watch || {} },
    finished() { return ["ending", "completed", "discarded"].includes(this.state.phase) },
    visible() { return this.state.owner === "watch" && this.state.phase !== "discarded" && this.state.syncState !== "saved" },
    stale() { return !this.finished && this.now - this.state.updatedAt > 30000 },
    statusText() {
      if (this.finished) return "Übertragung ausstehend"
      return this.state.phase === "paused" ? "Watch-Training pausiert" : "Training auf der Apple Watch"
    },
    duration() {
      const running = !this.finished && this.state.phase !== "paused"
      return this.formatDuration((this.state.elapsedSeconds || 0) + (running ? Math.max(0, (this.now - this.state.elapsedAnchorAt) / 1000) : 0))
    },
    restSeconds() { return this.state.phase === "resting" ? Math.max(0, (this.state.restEndsAt - this.now) / 1000) : 0 },
  },
  mounted() { this.timer = setInterval(() => { this.now = Date.now() }, 1000) },
  beforeDestroy() { clearInterval(this.timer) },
  methods: {
    formatDuration(value) { const seconds = Math.max(0, Math.floor(value || 0)); return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, "0")}` },
  },
}
</script>
